// ==================================================================================
// Digital Approval System (DAS) - useUserWorkflowSummary hook (U6)
// ==================================================================================
// All-time snapshot — no params; re-fetches only on refetch().
// ==================================================================================

import { useCallback, useEffect, useState } from 'react';
import { reportsService } from '../../../../api/services/das/reportsService';
import type { UserWorkflowSummaryDto } from '../../../../api/types/das/reports.types';

export const useUserWorkflowSummary = () => {
  const [data, setData] = useState<UserWorkflowSummaryDto | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await reportsService.getUserWorkflowSummary();
      setData(result);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Failed to load Workflow Summary dashboard';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  return { data, loading, error, refetch: fetchReport };
};
